<section class="carousel" >
    <div class="container row">
        <div class="col-4 slide" *ngFor="let item of data">
            <app-card [item]="item" type="clean"></app-card>
        </div>
    </div>
</section>
